const swiper = new Swiper(".swiper", {
  // Optional parameters
  slidesPerView: 3,
  loop: true,
  centeredSlides: true,
    pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: {
    delay: 15000,
    disableOnInteraction: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1.3,
      spaceBetween: 10,
    },
    575: {
      slidesPerView: 1.3,
            spaceBetween: 10,
    },
    1024: {
      slidesPerView: 3,
    }
  }
});
